import React from "react";

const Reminder = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill}
            d="M31 16.51a1.334 1.334 0 0 1-1.333-1.334c0-3.74-1.456-7.255-4.1-9.9a1.332 1.332 0 0 1 0-1.885 1.332 1.332 0 0 1 1.885 0 16.556 16.556 0 0 1 4.881 11.785c0 .736-.597 1.333-1.333 1.333Zm-26.667 0A1.334 1.334 0 0 1 3 15.175c0-4.452 1.733-8.637 4.881-11.785a1.332 1.332 0 0 1 1.886 0 1.332 1.332 0 0 1 0 1.885 13.909 13.909 0 0 0-4.1 9.9c0 .736-.598 1.333-1.334 1.333Zm25.84 8.04A8.931 8.931 0 0 1 27 17.718V14c0-4.692-3.485-8.576-8-9.227v-1.44a1.333 1.333 0 1 0-2.667 0v1.44c-4.516.651-8 4.535-8 9.227v3.717a8.94 8.94 0 0 1-3.184 6.844 2.327 2.327 0 0 0-.816 1.772 2.336 2.336 0 0 0 2.334 2.334h22A2.336 2.336 0 0 0 31 26.333c0-.682-.297-1.328-.828-1.782ZM17.666 34a5.008 5.008 0 0 0 4.898-4h-9.797a5.008 5.008 0 0 0 4.899 4Z"
        />
    </svg>
);

export default Reminder;